import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { Reveal } from "./Reveal";
import { API, FALLBACK_FAQS } from "../../data/content";

const FAQ = () => {
  const [faqs, setFaqs] = useState(FALLBACK_FAQS);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/faqs`)
      .then((res) => {
        if (active && Array.isArray(res.data) && res.data.length > 0) {
          setFaqs(res.data);
        }
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <p className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-5">
                / FAQ
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white">
                Common questions.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-zinc-400 leading-relaxed">
                Quick answers for getting started and understanding what ROLL.OPS
                does — and doesn't — do.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <Reveal delay={0.1}>
              <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                {faqs.map((f, i) => (
                  <AccordionItem
                    key={f.id}
                    value={f.id}
                    data-testid={`faq-item-${i + 1}`}
                    className="border-b border-white/10"
                  >
                    <AccordionTrigger
                      data-testid={`faq-trigger-${i + 1}`}
                      className="text-left font-display text-lg md:text-xl font-medium text-white hover:no-underline hover:text-cyan-300 py-6"
                    >
                      {f.question}
                    </AccordionTrigger>
                    <AccordionContent
                      data-testid={`faq-content-${i + 1}`}
                      className="text-zinc-400 text-base leading-relaxed pb-6"
                    >
                      {f.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
